import { render, staticRenderFns } from "./currencyAnalysis.vue?vue&type=template&id=4e4c086b&"
import script from "./currencyAnalysis.vue?vue&type=script&lang=js&"
export * from "./currencyAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e4c086b')) {
      api.createRecord('4e4c086b', component.options)
    } else {
      api.reload('4e4c086b', component.options)
    }
    module.hot.accept("./currencyAnalysis.vue?vue&type=template&id=4e4c086b&", function () {
      api.rerender('4e4c086b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameData/actionAnalysis/currencyAnalysis.vue"
export default component.exports